<template>
  <v-container fluid mx-auto v-bind="$attrs" v-on="$listeners" px-3>
    <slot />
  </v-container>
</template>

<script>
export default {
  name: "base-container",
  inheritAttrs: false
};
</script>